import { Navigate } from 'react-router';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useAuth } from '@/hooks/useAuth';

/**
 * ClubAdminGuard - PROTECTS ROUTES THAT REQUIRE CLUB ADMIN ROLE
 * REDIRECTS NON-CLUB-ADMIN USERS TO THE DASHBOARD
 */

export function ClubAdminGuard({ children }) {
  const { user, isLoading } = useAuth();

  // Show spinner while loading user data
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // Check if user has club_admin role
  const roles = user?.roles || [];
  const hasClubAdminRole = roles.some(role => role.roleType === 'club_admin');

  // Redirect to dashboard if not a club admin
  if (!hasClubAdminRole) {
    return <Navigate replace to="/dashboard" />;
  }

  return <>{children}</>;
}
